var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loader"},[_c('div',{ref:"first",staticClass:"word-loader"}),(_vm.rows > 1)?_c('div',{ref:"second",staticClass:"word-loader"}):_vm._e(),(_vm.rows > 2)?_c('div',{ref:"third",staticClass:"word-loader"}):_vm._e(),(_vm.rows > 3)?_c('div',{ref:"fourth",staticClass:"word-loader"}):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }